var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"page-title title__large"},[_vm._t("left-icon"),_vm._v(" "+_vm._s(_vm.title)+" "),_c('div',{staticClass:"slot-wrapper"},[_vm._t("icon")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }